import axios from 'axios';

// Types kept minimal to avoid tight coupling with backend DTOs
export async function getCollection(id: string): Promise<any> {
  const { data } = await axios.get(`/api/chroma/collections/${encodeURIComponent(id)}`);
  return data;
}

export async function addItemByName(id: string, payload: { name: string; document?: string }): Promise<any> {
  const { data } = await axios.post(`/api/chroma/collections/${encodeURIComponent(id)}/add-by-name`, payload);
  return data;
}

export async function deleteItems(id: string, ids: string[]): Promise<any> {
  const { data } = await axios.post(`/api/chroma/collections/${encodeURIComponent(id)}/delete`, { ids });
  return data;
}

export async function queryItemsByText(
  id: string,
  payload: { query: string; nResults?: number; where?: Record<string, any>; whereDocument?: Record<string, any> }
): Promise<any> {
  const { data } = await axios.post(`/api/chroma/collections/${encodeURIComponent(id)}/query-text`, payload);
  return data;
}
